import {formatLeadStatus} from './leads';
import config from '../config/config';

export const getPatientStatuses = () => ([
  {label: 'Scheduled', value: 'Scheduled'},
  {label: 'Unscheduled', value: 'Unscheduled'},
  {label: 'Goals Met', value: 'Goals Met'},
  {label: 'Referred Out', value: 'Referred Out'},
  {label: 'Lost', value: 'Lost'},
]);

export const getRelations = () => (
  [
    {
      label: 'Parent',
      value: 'parent',
    },
    {
      label: 'Grandparent',
      value: 'grandparent',
    },
    {
      label: 'Spouse / Partner',
      value: 'partner',
    },
    {
      label: 'Child',
      value: 'child',
    },
    {
      label: 'Sibling',
      value: 'sibling',
    },
    {
      label: 'Other Relative',
      value: 'otherRelative',
    },
    {
      label: 'Legal Guardian',
      value: 'legalGuardian',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ]
);

export const getStates = () => ([
  {value: 'AL', label: 'AL'},
  {value: 'AK', label: 'AK'},
  {value: 'AZ', label: 'AZ'},
  {value: 'AR', label: 'AR'},
  {value: 'CA', label: 'CA'},
  {value: 'CO', label: 'CO'},
  {value: 'CT', label: 'CT'},
  {value: 'DC', label: 'DC'},
  {value: 'DE', label: 'DE'},
  {value: 'FL', label: 'FL'},
  {value: 'GA', label: 'GA'},
  {value: 'HI', label: 'HI'},
  {value: 'ID', label: 'ID'},
  {value: 'IL', label: 'IL'},
  {value: 'IN', label: 'IN'},
  {value: 'IA', label: 'IA'},
  {value: 'KS', label: 'KS'},
  {value: 'KY', label: 'KY'},
  {value: 'LA', label: 'LA'},
  {value: 'ME', label: 'ME'},
  {value: 'MD', label: 'MD'},
  {value: 'MA', label: 'MA'},
  {value: 'MI', label: 'MI'},
  {value: 'MN', label: 'MN'},
  {value: 'MS', label: 'MS'},
  {value: 'MO', label: 'MO'},
  {value: 'MT', label: 'MT'},
  {value: 'NE', label: 'NE'},
  {value: 'NV', label: 'NV'},
  {value: 'NH', label: 'NH'},
  {value: 'NJ', label: 'NJ'},
  {value: 'NM', label: 'NM'},
  {value: 'NY', label: 'NY'},
  {value: 'NC', label: 'NC'},
  {value: 'ND', label: 'ND'},
  {value: 'OH', label: 'OH'},
  {value: 'OK', label: 'OK'},
  {value: 'OR', label: 'OR'},
  {value: 'PA', label: 'PA'},
  {value: 'RI', label: 'RI'},
  {value: 'SC', label: 'SC'},
  {value: 'SD', label: 'SD'},
  {value: 'TN', label: 'TN'},
  {value: 'TX', label: 'TX'},
  {value: 'UT', label: 'UT'},
  {value: 'VT', label: 'VT'},
  {value: 'VA', label: 'VA'},
  {value: 'WA', label: 'WA'},
  {value: 'WV', label: 'WV'},
  {value: 'WI', label: 'WI'},
  {value: 'WY', label: 'WY'},
]);

export const getReferralSourceCategories = () => (
  [
    {
      value: 'friendAndFamily',
      label: 'Recommendation from Friend or Family',
      followup: 'Name of your friend/family member',
    },
    {
      value: 'physician',
      label: 'Referral from Doctor or Healthcare Provider ',
      followup: 'What doctor or practice referred you?',
    },
    {
      value: 'communityPartner',
      label: 'Through a Local Gym, Company, or Event',
      followup: 'What community partner or gym?',
    },
    {
      value: 'search',
      label: 'Online Search',
      followup: 'What search website or listserv?',
    },
    {
      value: 'socialMedia',
      label: 'Social Media',
      followup: 'What social media platform?',
    },
    {
      value: 'previousPatient',
      label: 'I’m a Previous Patient from Another Clinic',
      followup: 'Which provider did you work with?',
    },
    {
      value: 'provider',
      label: '(Archived) I know a MovementX Provider',
      followup: 'Which provider do you know?',
      disabled: true,
    },
    {
      value: 'other',
      label: 'Other',
      followup: 'How did you hear about us?',
    },
  ]
);

export const getLeadStatusOptions = () => ([
  {label: 'New Patient Lead', value: 'NEW'},
  {label: 'Signed Up on Platform', value: 'SIGNED_UP'},
  {label: 'Eval Complete', value: 'EVALUATED'},
  {label: 'Lost Lead', value: 'LOST'},
  {label: 'No Status', value: 'NONE'},
]);

export const getMarketingStrategyOptions = () => ([
  {label: 'Previous Patient', value: 'PREVIOUS_PATIENT'},
  {label: '$30 for 30', value: 'THIRTY_FOR_THIRTY'},
  {label: 'Physician Shadowing', value: 'PHYSICIAN_SHADOWING'},
  {label: 'Networking Group', value: 'NETWORKING_GROUP'},
  {label: 'Meet and Treat', value: 'MEET_AND_TREAT'},
  {label: 'Meet and Move', value: 'MEET_AND_MOVE'},
  {label: 'Meet and Learn', value: 'MEET_AND_LEARN'},
  {label: 'Meet and Teach', value: 'MEET_AND_TEACH'},
  {label: 'Workshop', value: 'WORKSHOP'},
  {label: 'Virtual Event', value: 'VIRTUAL_EVENT'},
  {label: 'Free Screenings', value: 'FREE_SCREENINGS'},
  {label: 'Trail Run', value: 'TRAIL_RUN'},
  {label: 'In-Building Marketing', value: 'IN_BUILDING_MARKETING'},
  {label: 'Corporate Marketing', value: 'CORPORATE_MARKETING'},
]);

export const getCaseStatuses = () => ([
  {value: 'ACTIVE', label: 'Active'},
  {value: 'GOALS_MET', label: 'Complete - Goals Met'},
  {value: 'LOST', label: 'Complete - Lost'},
  {value: 'REFERRED_OUT', label: 'Complete - Referred Out'},
]);

export const getCaseBillingTypes = () => ([
  {value: 'CASH', label: 'Cash Pay'},
  {value: 'COURTESY_BILL', label: 'Courtesy Bill (Admin Only)'},
  {value: 'DIRECT_BILL', label: 'Direct Bill (Admin Only)'},
]);

export const getSpecialties = () => ([
  { value: 'ORTHOPEDICS', label: 'Orthopedic & Musculoskeletal' },
  { value: 'NEUROLOGIC', label: 'Neurological Conditions' },
  { value: 'SPORTS', label: 'Sports Injuries' },
  { value: 'PELVIC_HEALTH', label: 'Pelvic Health & Pregnancy' },
  { value: 'PEDIATRICS', label: 'Pediatric Conditions' },
  { value: 'VESTIBULAR', label: 'Vestibular Conditions' },
  { value: 'PERSONAL_TRAINING', label: 'Personal Training & Fitness' },
  { value: 'GERIATRICS', label: 'Geriatrics' },
]);

export const getClaimStatuses = () => ([
  { value: 'READY_TO_UPLOAD', label: 'Ready to Upload' },
  { value: 'UPLOADED', label: 'Uploaded' },
  { value: 'RECEIVED', label: 'Transmitted' },
  { value: 'NOTE_UPLOADED', label: 'Note Attached' },
  { value: 'SUBMISSION_COMPLETED', label: 'Submission Completed' },
  { value: 'PAID', label: 'Paid' },
  { value: 'PATIENT_PAID', label: 'Patient Paid' },
  { value: 'UNDERPAID', label: 'Underpaid' },
  { value: 'ACTION', label: 'Action' },
  { value: 'CANCELED', label: 'Canceled' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'DENIED', label: 'Denied' },
  // { value: 'COMPLETED', label: '' },
  { value: 'UPLOAD_ERROR', label: 'Error - Uploading' },
  { value: 'RECEIVED_ERROR', label: 'Error - Receiving' },
  { value: 'NOTE_UPLOAD_FAILED', label: 'Error - Uploading Note' },
  { value: 'SUBMISSION_COMPLETED_ERROR', label: 'Error - Completing Submittion' },
]);

export const getLeadStatuses = () => ([
  { value: 'NEW', label: formatLeadStatus({status: 'NEW'}) },
  { value: 'CREATED_ACCOUNT', label: formatLeadStatus({status:  'CREATED_ACCOUNT'}) },
  { value: 'COMPLETED_SIGNUP', label: formatLeadStatus({status:  'COMPLETED_SIGNUP'}) },
  { value: 'SCHEDULED', label: formatLeadStatus({status:  'SCHEDULED'}) },
  { value: 'EVALUATED', label: formatLeadStatus({status:  'EVALUATED'}) },
  { value: 'LOST', label: formatLeadStatus({status:  'LOST'}) },
  { value: 'ARCHIVED', label: formatLeadStatus({status:  'ARCHIVED'}) },
]);

export const getCancelReasons = () => (
  [
    {value: 'FORGOT_OR_NO_SHOW', label: 'Patient Forgot (or No-showed)'},
    {value: 'ILLNESS', label: 'Illness'},
    {value: 'SCHEDULE_CONFLICT', label: 'Schedule Conflict'},
    {value: 'WEATHER', label: 'Weather'},
    {value: 'SYMPTOMS_IMPROVED', label: 'Symptoms Improved'},
    {value: 'SYMPTOMS_WORSENED', label: 'Symptoms Worsened'},
    {value: 'REFERRED_OUT', label: 'Referred Out'},
    {value: 'GOALS_MET', label: 'Goals Met (Plan of Care Ended)'},
    {value: 'OTHER', label: 'Other'},
  ]
);

export const getEventCategories = () => ([
  {value: 'ADMIN_TIME', label: 'Marketing and Meeting Time'},
]);

export const getServiceCategories = () => ([
  {value: 'PHYSICAL_THERAPY', label: 'Physical Therapy', color: config().colors.primary, colorName: 'primary'},
  {value: 'FITNESS', label: 'Personal Training & Fitness', color: config().colors.secondary, colorName: 'secondary'},
  {value: 'SPORTS_PERFORMANCE', label: 'Sports Performance', color: config().colors.warning, colorName: 'warning'},
  {value: 'NUTRITION', label: 'Nutrition', color: config().colors.success, colorName: 'success'},
  {value: 'WELLNESS', label: 'Wellness & Recovery', color: config().colors.info, colorName: 'info'},
  {value: 'FREE_EVAL', label: 'Free Consult', color: config().colors.lightTeal, colorName: 'lightTeal'},
  {value: 'THIRTY_FOR_THIRTY', label: '30-for-30', color: config().colors.teal, colorName: 'teal'},
  {value: 'CHIROPRACTIC_REHAB', label: 'Chiropractic Rehab', color: config().colors.info, colorName: 'info'},
]);

export const getLocationTypes = () => ([
  {
    label: '🏋️ Facility', 
    value: 'PARTNER', 
    emoji: '🏋️',
    description: 'See a provider at one of our partner facilities.',
  },
  {
    label: '🏠 In-Home', 
    value: 'HOME', 
    emoji: '🏠',
    description: 'We’ll send a provider to your home for sessions.',
  },
  {
    label: '🚗 Mobile', 
    value: 'MOBILE', 
    emoji: '🚗',
    description: 'We’ll send a provider to a location of your choice.',
  },
  {
    label: '💻 Virtual', 
    value: 'VIRTUAL', 
    emoji: '💻',
    description: 'Attend sessions virtually from anywhere.',
  },
]);